export function focusActiveTab() {
  const activeElement = document.querySelector('[aria-current="page"]');

  if (activeElement instanceof HTMLElement) {
    activeElement.focus();
  }
}
